/**
 * The Metafolder Administration Client
 */
export class AdministrationClient {
    constructor(clearCacheFunc) {
        this.clearCacheFunc = clearCacheFunc;
    }
    /** @inheritdoc */
    async clearCache() {
        return this.clearCacheFunc();
    }
}
//# sourceMappingURL=administrationClient.js.map